import "./fullScreenGrid.css";
import "@src/pages/businessAnalysis/businessAnalysis.css";
import { Modal } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

/**
 * A full-screen pop-up laid out like a module page: the coloured title bar every pop-up has
 * (title, count, close), then a line about what it's for with the numbers strip on the right
 * (as on Business Analysis), then whatever the page shows (tabs, toolbar, grid). Used by the
 * dashboard's request tiles.
 */
export const FullScreenGrid = ({ visible, onClose, title, subtitle, intro, stats, children }) => (
    <Modal open={visible} onCancel={onClose} footer={null} closable={false} width="100%" className="fsg-modal" destroyOnClose>
        <div className="modal-header-title fsg-header">
            <span>{title}{subtitle && <span className="fsg-header-count">{` - ${subtitle}`}</span>}</span>
            <span onClick={onClose}><FontAwesomeIcon className="close" icon={faClose} /></span>
        </div>
        <div className="fsg-page">
            <div className="fsg-head">
                {intro && <div className="fsg-intro">{intro}</div>}
                {stats?.length > 0 && (
                    <div className="ba-stat-strip">
                        {stats.map((stat) => (
                            <div className="ba-stat" key={stat.label}>
                                <span className="ba-stat-num">{stat.value}</span>
                                <span className="ba-stat-lbl">{stat.label}</span>
                            </div>
                        ))}
                    </div>
                )}
            </div>
            {children}
        </div>
    </Modal>
);
